import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ControlCenterType } from '../../../shopfloor/ccs/control-center'
import { ControlTerminal } from '../../control-terminal'
import { ElderWideScrollbarDirective } from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-control-terminal',
  templateUrl: './control-terminal.component.html',
  styleUrls: ['./control-terminal.component.scss'],
  imports: [RouterOutlet, ElderWideScrollbarDirective],
})
export class ControlTerminalComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)
  private router = inject(Router)
  private route = inject(ActivatedRoute)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const ct = this.route.snapshot.data['controlTerminal'] as ControlTerminal

    if (ct) {
      this.log.debug('Initializing control terminal view for terminal:', ct)

      switch (ct.type) {
        case ControlCenterType.WORK_STATION:
          this.navigateIfNecessary('work-centers')
          break
        case ControlCenterType.STORAGE:
          this.navigateIfNecessary('storage')
          break
      }
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private navigateIfNecessary(childPath: string): void {
    if (!location.href.includes(childPath)) {
      // TODO somewhat hacky
      console.debug(`navigation necessary: ${childPath}`)
      this.router.navigate([childPath], {
        relativeTo: this.route,
        queryParams: this.route.snapshot.queryParams,
      })
    }
  }
}
